import React from "react";
import {
  CandidateAboutWrapper,
  Row,
  Title,
  TitleItem,
  InnerItem,
  Inner,
} from "./styles/candidate-about-styles";

const CandidateAbout = (props) => {
  const { jobCurrencySymbol, about } = props;
  const {
    current_salary: currentSalary,
    desired_salary: desiredSalary,
    nationality,
    location,
    has_driving_licence: hasDrivingLicence,
    job_type: jobType,
  } = about;

  let drivingLicence;
  if (hasDrivingLicence) {
    drivingLicence = "Yes";
  } else {
    drivingLicence = "No";
  }

  let jobTypeString;
  if (jobType === "Perm") {
    jobTypeString = "Permanent";
  } else {
    jobTypeString = "Contract";
  }

  return (
    <CandidateAboutWrapper>
      <Row>
        <Title>
          <TitleItem>Current Salary</TitleItem>
          <TitleItem>Desired Salary</TitleItem>
        </Title>
        <Inner>
          <InnerItem>
            {jobCurrencySymbol}
            {currentSalary}
          </InnerItem>
          <InnerItem>
            {jobCurrencySymbol}
            {desiredSalary}
          </InnerItem>
        </Inner>
      </Row>
      <Row>
        <Title>
          <TitleItem>Nationality</TitleItem>
          <TitleItem>Driving licence</TitleItem>
        </Title>
        <Inner>
          <InnerItem>{nationality}</InnerItem>
          <InnerItem>{drivingLicence}</InnerItem>
        </Inner>
      </Row>
      <Row>
        <Title>
          <TitleItem>Location</TitleItem>
        </Title>
        <Inner>
          <InnerItem>{location}</InnerItem>
        </Inner>
      </Row>
      <Row>
        <Title>
          <TitleItem>Job Type</TitleItem>
        </Title>
        <Inner>
          <InnerItem>{jobTypeString}</InnerItem>
        </Inner>
      </Row>
    </CandidateAboutWrapper>
  );
};

export default CandidateAbout;
